import { isPlainObject, isArray } from 'lodash-es'

const transformer = function (origin, defs) {
  const ret = { render: 'text', origin, value: origin, defs }

  if (isPlainObject(origin)) {
    ret.value = origin.title
  }

  if (isArray(origin)) {
    ret.value = origin.map((v) => v.title)
  }

  return ret
}

export default transformer
